import { injectIntl } from "react-intl";
import { KeyValue } from "./KeyValue";
class ReportedProperty extends KeyValue {
  keyPlaceholderId = 'au.filters.reportedProperty.key';
  valuePlaceholderId = 'au.filters.property.value';
}

export default injectIntl(ReportedProperty);